<template>
  <div>
    <vs-card
      ><div slot="header">
        <h3>Cadastro de veículo que dispensa Vistoria Prévia</h3>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/4 w-full">
          <span>Tipo de Veículo</span>
          <v-select
            placeholder="Selecione o tipo do veículo"
            :options="fipeTypes"
            name="tipo do veículo"
            id="tipo do veículo"
            v-model="vehicleType"
            v-validate="{ required: true }"
            :state="validateState(veeFields, veeErrors, 'tipo do veículo')"
            :class="validateStateClass(veeFields, veeErrors, 'tipo do veículo')"
          />
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <span>Marca do Veículo</span>
          <v-select
            placeholder="Selecione a marca do veículo"
            :options="brands"
            name="marca do veículo"
            id="marca do veículo"
            v-model="vehicleBrand"
            v-validate="{ required: true }"
            :state="validateState(veeFields, veeErrors, 'marca do veículo')"
            :class="
              validateStateClass(veeFields, veeErrors, 'marca do veículo')
            "
          />
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <span>Modelo do Veículo</span>
          <v-select
            placeholder="Selecione o modelo do veículo"
            :options="models"
            name="modelo do veículo"
            id="modelo do veículo"
            v-model="vehicleModel"
            v-validate="{ required: false }"
            :state="validateState(veeFields, veeErrors, 'modelo do veículo')"
            :class="
              validateStateClass(veeFields, veeErrors, 'modelo do veículo')
            "
          />
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <span>Ano do Veículo</span>
          <v-select
            placeholder="Selecione o ano do veículo"
            :options="years"
            name="ano do veículo"
            id="ano do veículo"
            v-model="vehicleYear"
            v-validate="{ required: false }"
            :state="validateState(veeFields, veeErrors, 'ano do veículo')"
            :class="validateStateClass(veeFields, veeErrors, 'ano do veículo')"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button color="success" class="mr-3 mb-2" @click="register"
            >Adicionar</vs-button
          >
        </div>
      </div>

      <ErrorsAlert :errors="errors" />
    </vs-card>

    <vx-card class="mt-4">
      <div id="data-list-list-view" class="data-list-container">
        <vs-table
          noDataText="Nenhuma Regra Encontrada"
          class="tablePrincipal"
          ref="table"
          v-model="selected"
          pagination
          :max-items="itemsPerPage"
          :data="itens"
        >
          <div slot="header" class="flex flex-grow justify-between">
            <vs-button
              color="primary"
              type="border"
              class="h-12"
              @click="goBack"
              >Voltar</vs-button
            >

            <!------------ START ITENS POR PÁGINA -->
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
              <div
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2"
                  >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                  {{
                    itens.length - currentPage * itemsPerPage > 0
                      ? currentPage * itemsPerPage
                      : itens.length
                  }}
                  de {{ itens.length }}</span
                >
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>

              <vs-dropdown-menu>
                <vs-dropdown-item @click="itemsPerPage = 5">
                  <span>5</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 25">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 50">
                  <span>50</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
            <!------------ END ITENS POR PÁGINA -->
          </div>
          <template slot="thead">
            <vs-th sort-key="nome">Tipo</vs-th>
            <vs-th sort-key="exigencia">Marca</vs-th>
            <vs-th sort-key="exigencia">Modelo</vs-th>
            <vs-th sort-key="exigencia">Ano</vs-th>
            <vs-th>Ações</vs-th>
          </template>
          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td class="w-1/5">
                  <p class="product-category">{{ tr.vehicleType.label }}</p>
                </vs-td>
                <vs-td class="w-1/5">
                  <p class="product-category">
                    {{ tr.vehicleBrand.label }}
                  </p> </vs-td
                ><vs-td class="w-1/5">
                  <p class="product-category">
                    {{ tr.vehicleModel ? tr.vehicleModel.label : undefined }}
                  </p> </vs-td
                ><vs-td class="w-1/5">
                  <p class="product-category">
                    {{ tr.vehicleYear ? tr.vehicleYear.label : undefined }}
                  </p>
                </vs-td>
                <vs-td class="w-1/5">
                  <div style="width: 350px">
                    <vs-button
                      radius
                      v-tooltip="'Deletar'"
                      color="danger"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-trash"
                      class="d-inline"
                      @click="remove(tr)"
                    ></vs-button>
                  </div>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vx-card>
  </div>
</template>
<script>
import ErrorsAlert from '../../../../components/ErrorsAlert.vue';
import vSelect from 'vue-select';

import utilsList from '../../../../utils/list/index';
import functions from '../../../../utils/functions';
import notify from '../../../../utils/notify';
import services from '../../../../services';

export default {
  name: 'list-vistoria-previa-marca-modelo',
  components: {
    'v-select': vSelect,
    ErrorsAlert,
  },
  props: ['registrations'],
  data() {
    return {
      controller: 'prior-inspections',
      getColorByDeletedat: utilsList.getColorAtivoInativoByDeletedAt,
      getStatusByDeletedat: utilsList.getAtivoInativoByDeletedAt,
      validateState: utilsList.validateState,
      validateStateClass: utilsList.validateStateClass,
      getSelectData: functions.buscaDadosSelects,
      fipeTypes: [],
      brands: [],
      models: [],
      years: [],
      vehicleType: null,
      vehicleBrand: null,
      vehicleModel: null,
      vehicleYear: null,
      itemsPerPage: 5,
      currentPage: 1,
      itens: [],
      selected: [],
    };
  },
  created() {
    this.getSelectData('domTipoFipe', this.fipeTypes, 'nomeTipo', 'idTipoFipe');
    if (this.$props.registrations) {
      this.itens = this.$props.registrations;
    }
  },
  computed: {
    errors() {
      return this.$validator.errors.all();
    },
  },
  watch: {
    registrations(value) {
      if (value) {
        this.itens = JSON.parse(value);
      }
    },
    vehicleType(value) {
      this.getBrands(value.id);
    },
    vehicleBrand(value) {
      this.getModels(this.vehicleType.id, value.id);
    },
  },
  methods: {
    async getBrands(fipeCode) {
      this.vehicleBrands = null;
      this.models = [];
      this.vehicleModel = null;
      this.years = [];
      this.vehicleYear = null;

      const controoler = 'Fipe';
      const action = 'ConsultarMarcas';
      const body = { codigoTipoVeiculo: fipeCode };

      const { success, data } = await this.postData(controoler, action, body);

      if (success && Array.isArray(data)) {
        this.brands = data.map(({ id, name }) => ({ id, label: name }));
      }
    },
    async getModels(fipeCode, brandCode) {
      this.vehicleModel = null;
      this.years = [];
      this.vehicleYear = null;

      const controoler = 'Fipe';
      const action = 'ConsultarModelos';
      const body = { codigoTipoVeiculo: fipeCode, codigoMarca: brandCode };

      const { success, data } = await this.postData(controoler, action, body);

      if (success && Array.isArray(data)) {
        const [models, years] = data;
        this.models = models.map(({ id, name }) => ({ id, label: name }));
        this.years = years.map(({ id, name }) => ({ id, label: name }));
      }
    },
    async postData(controller, action, body) {
      try {
        this.$vs.loading();
        const { data } = await services.post(controller, action, body);
        return { success: true, data };
      } catch (error) {
        notify.notifyFail(this.$vs, error);
        return { success: false, data };
      } finally {
        this.$vs.loading.close();
      }
    },
    goBack() {
      this.$emit('goBack');
    },
    async register() {
      const valid = await this.$validator.validateAll();

      if (valid) {
        this.itens.push({
          vehicleType: this.vehicleType,
          vehicleBrand: this.vehicleBrand,
          vehicleModel: this.vehicleModel,
          vehicleYear: this.vehicleYear,
        });
        this.$emit('register', JSON.stringify(this.itens));
      }
    },
    remove(item) {
      this.itens = this.itens.filter(
        (i) => JSON.stringify(i) !== JSON.stringify(item),
      );
      this.$emit('register', JSON.stringify(this.itens));
    },
  },
};
</script>
<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
